/* eslint-disable no-console */
import React, { useEffect, useState } from 'react';
import { Grid, GridItem } from '@patternfly/react-core';
import { kebabCase } from 'lodash';
import moment from 'moment';
import { makeStyles } from '@material-ui/core';
import { commonNodeModules, commonModules } from '../index';
import DateFnsUtils from '@date-io/date-fns';
import { InputAdornment } from '@material-ui/core';
import { MuiPickersUtilsProvider, KeyboardDatePicker } from '@material-ui/pickers';
import InputRadio from './input_radio';
import TextFieldComponent from './TextFieldComponent';
import { formLabelsTheme } from '../../style_jsx/styles';
import { addOverflowClass, removeOverflowClass } from '../utils/string_utils';

const InputForm = (props) => {

  const { MuiThemeProvider, Box, TextField, MenuItem, isFutureDate } = commonNodeModules;
  const { useTranslateText } = commonModules;

  const { className, fields, titleText, titleSubText, onChange, subTexts } = props,
        { translateText } = useTranslateText(),
        classNames = `input-form ${className}`;


  const onChangeField = (key, value, oldValue) => {
    if (key === 'Zip') {
      value = value.replace(/[^0-9\\.]+/g, '');
      let withoutcomma = value.replace(/[^0-9\\.]+/g, '');
      if (withoutcomma.length > 5) {
        if (withoutcomma.length > 9) {
          value = withoutcomma.slice(0, 5) + '-' + withoutcomma.slice(5, 9) + '-' + withoutcomma.slice(9, 12);
        }
        else {
          value = withoutcomma.slice(0, 5) + '-' + withoutcomma.slice(5, 9);
        }
      }
    }
    else if (key === 'SubDivision') {
      const len = value.length - 1,
            oldValueLen = oldValue.length - 1,
            valArray = value.split(''),
            numRegx = /^[0-9]$/,
            isDeleteKeyUp = oldValueLen > len,
            lastDigit = valArray[len];
      if (len > 0 && !isDeleteKeyUp) {
        if (!numRegx.test(lastDigit)) return;
        if (key === 'SubDivision' && len > 5) return;
      }
      value = valArray.join('');
    }
    onChange(key, value);
  };

  const [selectedDate, setDate] = useState(null);
  const [errorDate, setErrorDate] = useState(false);

  useEffect(() => (
    fields && fields.map((item => {
      if (item.key === 'Date_of_Birth') {
        setDate(item.value);
        onChange('Date_of_Birth', moment(item.value).format('MM/DD/YYYY'));
      }
    }))
  ), []);

  const onDateChange = (date, value) => {
    setDate(date);
    let newVal = '';
    if ((value != null)) {
      if (String(value.includes('_'))) {
        newVal = value.replaceAll('_', '');
      }
      else {
        newVal = value;
      }
      if (newVal.length === 10 && JSON.stringify(date) !== 'null') {
        onChange('Date_of_Birth', moment(date).format('MM/DD/YYYY'));
      }
      else {
        onChange('Date_of_Birth', date);
      }
    }
    else {
      onChange('Date_of_Birth', null);
      setErrorDate(true);
    }
  };

  return (
    <MuiThemeProvider theme={formLabelsTheme}>
      <Grid className={classNames}>
        <GridItem lg={12}>
          {titleText &&
        <>
          <p className="f20-title pb-3">{translateText(titleText)}
            {titleSubText && <span className="f16-content pl-3">{translateText(titleSubText)}</span>}
          </p>
          {subTexts}
        </>
          }
        </GridItem>
        {fields && fields.map((item, i) => {

          const { name, type, value, items, isDisable, key, errorMessage, error, index, isHidden, isPSDText, maxLength } = item,
                isText = type === '',
                isInputText = type === 'text',
                isDropdown = type === 'dropdown',
                isDatepicker = type === 'date',
                isRadio = type === 'radio',
                isPhone = type === 'phone',

                itemProps = {
                  key: value,
                  selectedItem: value,
                  disabled: isDisable,
                  data: items,
                  stateName: key,
                  value: value,
                  name: key,
                  lable: name,
                  autoComplete: 'off',
                  errorMessage,
                  index,
                  error,
                  maxDate: moment().subtract(1, 'days'),
                };

          return (
            <>
              {!isHidden &&
            <>
              <GridItem lg={3} key={i} className="pb-3 pr-3">
                <p className="f14-title"><span>{translateText(name)}</span></p>
                {isText && <p className="f14-content">{value}</p>}
                {isInputText &&
                  <TextFieldComponent
                    value={value}
                    disabled={isDisable}
                    name={key}
                    maxLength={maxLength}
                    required
                    lable=""
                    onChange={(e) => onChangeField(key, e.target.value, value)}
                    error={error}
                    helperText={error ?
                      <Box component="span">{translateText(errorMessage)}</Box> : null}
                  />
                }
                {isDatepicker &&

                  <Box className="datePickerContainer"
                    style = {{ height: '28px', marginTop: '-10px' }}>
                    <MuiThemeProvider theme={formLabelsTheme}>
                      <MuiPickersUtilsProvider utils={DateFnsUtils}>
                        {/* <Grid container> */}
                        <DatePickerComponent
                          className="datePickerEffective"
                          defaultValue={value ? value : selectedDate}
                          handleDateChange={onDateChange}
                          error= {Boolean(!selectedDate && errorDate) || Boolean(JSON.stringify(selectedDate) === 'null') ? true : false
                          || isFutureDate(selectedDate) || error
                          }
                          helperText={(!selectedDate && (errorDate || error)) ?
                            <Box style={{ 'marginLeft': '-1rem' }} component="span">
                              {translateText('Date of Birth is required.')}</Box> : (JSON.stringify(selectedDate) === 'null')
                              ? <Box style={{ 'marginLeft': '-1rem' }} component="span">
                                {translateText('Invalid Date')}</Box> : isFutureDate(selectedDate)
                                ? <Box style={{ 'marginLeft': '-1rem' }} component="span">
                                  {translateText(`DOB should not be later than Today's Date.`)}</Box> : ''}
                          disabled={isDisable}
                        />
                      </MuiPickersUtilsProvider>
                    </MuiThemeProvider>
                  </Box>
                }
                {isDropdown && items.length > 0 && <Box>
                  <TextField variant="outlined" select
                    className="FTE_select"
                    InputLabelProps={{ shrink: false, margin: 'dense',
                    }}
                    value={value || ' '}
                    fullWidth
                    name={name}
                    error={error}
                    helperText={error ? <Box component="span">{translateText(errorMessage)}</Box> : null}
                    onChange={(e) => onChange(key, e.target.value, index)}
                    SelectProps={{
                      onOpen: () => addOverflowClass(),
                      onClose: () => removeOverflowClass(),
                    }}
                  >
                    {items.map((item, i) => {
                      return <MenuItem key={i} value={item.value || ' '}>
                        {translateText(item.label)}
                      </MenuItem>;
                    })}
                  </TextField>
                </Box>}
                {isRadio && <InputRadio {...{ ...itemProps, onChange: value => onChange(key, value) }} />}
                {isPhone && <PhoneInput {...{ itemProps, onChange: value => onChange(key, value) }} />}
              </GridItem>
              {isPSDText &&
                <GridItem lg={3} key={i + 'psd'} className="pb-3 pr-3 mt-4">
                  <a target="_blank" style={{ fontSize: '11px' }}
                    href="https://dced.pa.gov/local-government/local-income-tax-information/psd-codes-and-eit-rates/" rel="noreferrer">
                    {translateText('Click here to look up the PSD Code.')}
                  </a>
                </GridItem>}
            </>
              }
            </>
          );
        })}
      </Grid>
    </MuiThemeProvider>
  );
};


const useStyles = makeStyles((theme) => ({
        root: {
          display: 'flex',
          flexDirection: 'column',
          flexWrap: 'wrap',
          [theme.breakpoints.down('sm')]: {
            overflow: 'auto',
          },
        },
        input: {
          height: 40,
          padding: 0,
          [theme.breakpoints.up('300')]: {
            width: 130,
          },
          [theme.breakpoints.up('576')]: {
            width: 140,
          },
          [theme.breakpoints.up('768')]: {
            width: 160,
          },
          [theme.breakpoints.up('1024')]: {
            width: 160,
          },
          color: '#76787A',
          fontSize: '14px',
        },
        datepicker: {
          'label + &': {
            marginBottom: 60,
            backgroundColor: 'red',
          },

        },
        checked: {},
      })),

      DatePickerComponent = (props) => {

        const classes = useStyles();
        const { Box } = commonNodeModules;
        let format = 'MM/dd/yyyy';
        let formatDate = props.field ? 'yyyy' : format;
        let views = props.field ? ['year'] : ['year', 'month', 'date'];
        return (
          <Grid item xs={12} className={classes.textFieldGrid}>

            <KeyboardDatePicker
              maxDate={new Date()}
              views={views}
              // placeholder="-"
              inputVariant="outlined"
              format={formatDate}
              margin="dense"
              label=""
              value={props.defaultValue}
              onChange={props.handleDateChange}
              className={classes.datepicker}
              InputProps={{
                disableUnderline: true,
                color: '#76787A',
                className: `${classes.input}`,
                endAdornment: (
                  <InputAdornment position="end">
                    <Box
                      onClick={() => {}}
                      className="calendarIcon"
                    />
                  </InputAdornment>
                ),
              }}
              // InputAdornmentProps = {{ position: 'right' }}
              fullWidth
              error={props.error}
              helperText={props.helperText}
              disabled={props.disabled}
            />
          </Grid>//
        );
      };

const PhoneInput = (props) => {

  const { Box } = commonNodeModules;
  const { useTranslateText } = commonModules;
  const { itemProps, onChange } = props,
        { translateText } = useTranslateText(),
        { value, stateName, key, error, errorMessage } = itemProps,
        id = `phone-${kebabCase(stateName)}`;

  const onChangeNumber = (newValue) => {
    const len = newValue.length - 1,
          oldValueLen = value.length - 1,
          valArray = newValue.split(''),
          numRegx = /^[0-9]$/,
          isDeleteKeyUp = oldValueLen > len,
          lastDigit = valArray[len],
          isValid = numRegx.test(lastDigit);

    if (len > 13) return;
    if (!isDeleteKeyUp) {
      if (!isValid) return;
      if (len === 0) valArray.splice(0, 0, '(');
      if (len === 3 || len === 4) {
        valArray.splice(4, 0, ')');
        valArray.splice(5, 0, ' ');
      }
      if (len === 5) valArray.splice(5, 0, ' ');
      if (len === 8 || len === 9) valArray.splice(9, 0, '-');
    }
    const val = valArray.join('');
    onChange(val);
  };

  return <TextFieldComponent
    id={id}
    value={value}
    name={key}
    required
    lable=""
    autoComplete="off"
    onChange={(e) => onChangeNumber(e.target.value)}
    error={error}
    helperText={error ?
      <Box component="span">{translateText(errorMessage)}</Box> : null}
  />;
};



export default InputForm;